import React, { useState } from 'react';
import './Testimonials.css';

const TESTIMONIALS = [
  {
    name: 'Gérald L.',
    note: 5,
    text: 'Une équipe gagnante et cordiale avec une commune entente. Un travail soigné et des matériaux de qualité. Une confiance totale en ces personnes à soutenir dans leur manière de travailler.',
  },
  {
    name: 'Jérémy P.',
    note: 5,
    text: 'Du très bon travail, l\'installation de la climatisation s\'est effectuée dans la journée malgré la complexité du travail en hauteur. La communication a été fluide et le travail de qualité professionnelle.',
  },
  {
    name: 'Mika B.',
    note: 5,
    text: 'Très pro, efficace, disponible pour ses clients et à l\'écoute. Je ne regrette pas d\'avoir fait appel à SOCLIMATE pour réparer et entretenir mes clim réversibles. Je le recommande vivement.',
  },
  {
    name: 'Sylvain Bl.',
    note: 5,
    text: 'Merci à toute l\'équipe SOCLIMATE d\'avoir installé notre système de climatisation dans notre établissement. Professionnel et réactif. Des personnes sérieuses et agréables. Je recommande vivement.',
  },
];

function Stars({ count = 5 }) {
  return (
    <div className="stars">
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} width="16" height="16" viewBox="0 0 24 24" fill="#fbbf24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      ))}
    </div>
  );
}

export default function Testimonials() {
  const [active, setActive] = useState(0);

  return (
    <section id="avis" className="testimonials">
      <div className="container">
        <div className="testimonials__header">
          <div className="about__label" style={{ color: 'var(--rouge)' }}>ILS PARLENT DE NOUS</div>
          <h2 className="section-title testimonials__title">
            LA SATISFACTION CLIENT,<br/>
            <span className="testimonials__accent">NOTRE PRIORITÉ</span>
          </h2>
        </div>

        <div className="testimonials__grid">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className={`testimonials__card ${active === i ? 'testimonials__card--featured' : ''}`}
              onClick={() => setActive(i)}
            >
              <Stars count={t.note} />
              <p className="testimonials__text">"{t.text}"</p>
              <div className="testimonials__author">
                <div className="testimonials__avatar">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <strong>{t.name}</strong>
                  <small>Client vérifié</small>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="testimonials__score">
          <div className="testimonials__score-num">5.0</div>
          <div>
            <Stars count={5} />
            <p>Note moyenne · 4 avis clients</p>
          </div>
          <a
            href="https://www.google.com/search?sa=X&sca_esv=cdf1ae9af23e2b08&sxsrf=ANbL-n5VvCjtSV26njGL1onKqcpSWhXA1g:1774346039949&q=SOCLIMATE%E2%80%93+Climatisation+%26+pompe+%C3%A0+chaleur+Avis&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxI2MTCxMLE0NjSxMDc0NzOwMDA12MDI-IrRKNjf2cfT1zHE9VHDZAXnnMzcxJLMYiDOz1NQUyjIzy1IVTi8QCE5IzEntbRIwbEss3gRKxmaAGcvG4aEAAAA&rldimm=4048493148717608050&tbm=lcl&hl=fr-FR&ved=2ahUKEwjjxq2LoriTAxVLfaQEHREKKYAQ9fQKegQIKhAG&biw=1920&bih=945&dpr=1#lkt=LocalPoiReviews"
            target="_blank"
            rel="noopener noreferrer"
            className="testimonials__google"
          >
            Voir sur Google
          </a>
        </div>
      </div>
    </section>
  );
}
